import React from 'react'
import PropTypes from 'prop-types'
import { Steps } from 'shpmtcd'

const { Step } = Steps

const Ordered = (date, id) => ({
  steps: <Step title='Ordered' description={date} />,
  desc: <Description label='Order code' value={`#${id}`} />,
})

const InTransit = (date) => ({
  steps: <Step title='In Transit' description={date} />,
  desc: null,
})

const Delivered = (date, status) => ({
  steps: <Step title='Delivered' status={status ? 'finish' : 'wait'} description={date} />,
  desc: null,
})

const Returned = (date, status) => ({
  steps: <Step title='Returned' status={status ? 'finish' : 'wait'} description={date} />,
  desc: null,
})

const Refunded = (date, status) => ({
  steps: <Step title='Refunded' status={status ? 'finish' : 'wait'} description={date} />,
  desc: null,
})

const Canceled = (date) => ({
  steps: <Step title='Cancelled' status='error' description={date} />,
  desc: <p className='subinfo'>Cancelled by merchant</p>,
})

const Description = ({ label, value }) => (
  <p>
    <span className='bold'>{label}:</span>
    <span>{value}</span>
  </p>
)

const TrackStatus = ({
  partner, link, trackNumber, onClickCallback,
}) => (
  <p>
    <span className='bold'>
      Tracking code:
    </span>
    <span>
      {trackNumber
        ? (
          <span>
            <a
              href={link}
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => {
                onClickCallback()
              }}
            >
              {trackNumber}
            </a>&nbsp;
            <span>{`(${partner})`}</span>
          </span>
        )
        : 'Not Available'}
    </span>
  </p>
)

TrackStatus.propTypes = {
  partner: PropTypes.string.isRequired,
  trackNumber: PropTypes.string,
  link: PropTypes.string,
  onClickCallback: PropTypes.func.isRequired,
}

TrackStatus.defaultProps = {
  trackNumber: null,
  link: null,
}

Description.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
}

Description.defaultProps = {
  label: '',
  value: '',
}

export {
  Ordered,
  Canceled,
  Returned,
  Delivered,
  InTransit,
  Refunded,
  TrackStatus,
  Description,
}
